<div class="{{class}} Grid">
	<ul class="list-unstyled view-children"></ul>
	<div class="add editable" data-i18n="editor.addObject"></div>
</div>
